/**
 * Performing languages for profile performance details (API slug = display name).
 */

import type { MultiSelectOption } from '../components/ui/MultiSelect';

export const PERFORMING_LANGUAGE_NAMES: readonly string[] = [
  'Ao',
  'Assamese',
  'Awadhi',
  'Bagri',
  'Bengali',
  'Bhili',
  'Bhojpuri',
  'Bhotia',
  'Boro',
  'Chattisgarhi',
  'Deccani',
  'English',
  'Garhwali',
  'Garo',
  'Gondi',
  'Gujarati',
  'Haryanvi',
  'Hindi',
  'Ho',
  'Kanauji',
  'Kangri',
  'Kannada',
  'Khandeshi',
  'Khasi',
  'Kinnauri',
  'Konkani',
  'Konyak',
  'Kumaoni',
  'Kurux',
  'Lakher',
  'Lamani',
  'Lepcha',
  'Lushai',
  'Magahi',
  'Malayalam',
  'Malvi',
  'Manipuri',
  'Marathi',
  'Marwari',
  'Meitei',
  'Mundari',
  'Nepali',
  'Nimadi',
  'Nissi',
  'Odia',
  'Oriya',
  'Punjabi',
  'Rajasthani',
  'Sadri',
  'Santali',
  'Sema',
  'Sindhi',
  'Tamil',
  'Tangkhul',
  'Telugu',
  'Thadou',
  'Tripuri',
  'Tulu',
  'Urdu',
] as const;

/** Shown first when no language is selected yet */
export const DEFAULT_PERFORMING_LANGUAGE_PRIMARY: readonly string[] = [
  'English',
  'Hindi',
  'Punjabi',
  'Bengali',
];

export const PERFORMING_LANGUAGE_OPTIONS: MultiSelectOption[] =
  PERFORMING_LANGUAGE_NAMES.map((name) => ({ value: name, label: name }));

const KNOWN_LOWER = new Set(
  PERFORMING_LANGUAGE_NAMES.map((n) => n.toLowerCase()),
);

/** Map API / legacy slug to catalog value (e.g. english → English) */
export function canonicalPerformingLanguageSlug(raw: string): string {
  const t = raw?.trim() ?? '';
  if (!t) return t;
  const lower = t.toLowerCase();
  const hit = PERFORMING_LANGUAGE_NAMES.find((n) => n.toLowerCase() === lower);
  return hit ?? t;
}

export function isKnownPerformingLanguage(slug: string): boolean {
  return KNOWN_LOWER.has(slug.trim().toLowerCase());
}
